import { render, staticRenderFns } from "./view-more.vue?vue&type=template&id=35f33b29"
import script from "./view-more.vue?vue&type=script&lang=js"
export * from "./view-more.vue?vue&type=script&lang=js"
import style0 from "./view-more.vue?vue&type=style&index=0&id=35f33b29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports